module.exports = __webpack_public_path__ + "static/media/bg-image.8246d933.png";